"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { FeedbackIcon } from "@/components/feedback/FeedbackIcon";
import { CHAT_ROUTE, isChatRoute } from "@/lib/platform/chat-route";
import { isNotebookPathname } from "@/lib/notebook/core/notebook-route-entry";

import "@/components/feedback/feedback-icon.css";

/**
 * Global feedback entry — all authenticated sidebar routes except notebook detail + chat.
 */
export function FloatingFeedbackButton() {
  const pathname = usePathname();

  if (isNotebookPathname(pathname) || isChatRoute(pathname)) {
    return null;
  }

  return (
    <Link
      href={CHAT_ROUTE}
      prefetch
      className="feedback-float-link feedback-icon-trigger fixed bottom-6 right-6 z-[120]"
      aria-label="Share feedback"
      title="Share feedback"
    >
      <FeedbackIcon variant="floating" />
    </Link>
  );
}
